/**
 * Billing usage + the multi-tenant usage report. Both hit the mgmt API with the
 * dashboard's `ccBearerToken`.
 */

import constants from '../../constants'
import axiosInstance from '../axiosInstance'
import { toServiceError } from './errors'
import {
  BillingCycleUsage,
  MetricsApp,
  MetricsServiceError,
  MultiTenantUsageResponse,
} from './types'

/**
 * Usage for the app's current billing cycle. Record holds seconds, URL needs ms.
 * Response is flat — no `data` envelope.
 */
export async function getBillingCycleUsage(
  app: MetricsApp,
): Promise<BillingCycleUsage | MetricsServiceError> {
  let URL = `${constants.customerDomain}apps/${app.id}/billing/`

  if (app.isAnnual && app.monthlyTermStart && app.monthlyTermEnd) {
    URL = `${URL}${app.monthlyTermStart * 1000}/${app.monthlyTermEnd * 1000}`
  } else {
    URL = `${URL}${(app.currentTermStart as number) * 1000}/${(app.currentTermEnd as number) *
      1000}`
  }

  const ccBearerToken = localStorage.getItem('ccBearerToken')

  return axiosInstance
    .post(
      `${URL}`,
      { appids: [app.id] },
      {
        headers: { Authorization: `Bearer ${ccBearerToken}` },
      },
    )
    .then(res => res.data)
    .catch(toServiceError)
}

/**
 * EMAILS a usage report to the app owner — outward-facing, never call speculatively.
 * The unguarded catch can throw on network failure; see PROGRESS.md.
 */
export async function requestBillingUsage(
  postData: unknown,
  app: MetricsApp,
): Promise<MultiTenantUsageResponse | boolean> {
  const URL = `${constants.customerDomain}apps/${app.id}/usage`

  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axiosInstance.post(URL, postData, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
      return res.data
    }
  } catch (error) {
    return (error as { response: { data: MultiTenantUsageResponse } }).response.data
  }

  return false // Indicates ccBearerToken was not present in the local storage
}

export default function init(): void {}
